import { render, staticRenderFns } from "./ContactsExport.vue?vue&type=template&id=2b9d9106&scoped=true&"
import script from "./ContactsExport.vue?vue&type=script&lang=js&"
export * from "./ContactsExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d9106",
  null
  
)

export default component.exports